import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CustomAutocomplete from 'Common/CustomAutocomplete';
import { loadAutocomplete } from 'Actions/journal';
import { QueryFilterType } from 'Types';

@connect(
    store => ({
        journalsFilter: store.journalsListAutocomplete.filter,
        journalsData: store.journalsListAutocomplete.data,
    }),
    dispatch => ({
        loadAutocomplete: filter => dispatch(loadAutocomplete(filter)),
    })
)
export default class JournalAutocomplete extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        filter: PropTypes.object,
        journalsData: PropTypes.array,
        journalsFilter: QueryFilterType.isRequired,
        loadAutocomplete: PropTypes.func.isRequired,
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    static defaultProps = {
        filter: { where: {is_active: 1} },
    };

    componentDidMount() {
        const { journalsFilter, loadAutocomplete, filter } = this.props;
        loadAutocomplete(journalsFilter.merge(filter, {deep: true}));
    }

    /**
     * On change
     *
     * @param inputValue
     */
    handleInputChange = ( inputValue ) => {
        const { journalsFilter, loadAutocomplete, filter } = this.props;
        loadAutocomplete(journalsFilter.merge({ where: {is_active: 1, title: { like: `%${inputValue}%` } } })
            .merge(filter, {deep: true}));
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { journalsData, ...autocompleteProps } = this.props;
        const { intl: { formatMessage } } = this.context;

        return (
            <CustomAutocomplete
                placeholder={ formatMessage({ id: 'data_table.filter.journal_title' }) }
                {...autocompleteProps}
                options={[...journalsData.map(item => ({
                    label: item.title,
                    value: item.id,
                }))]}
                onInputChange={this.handleInputChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Autocomplete/JournalAutocomplete.jsx